const updates = [
  { time: '10分钟前', text: '某知名导演新片拍摄现场突发意外，剧组紧急停工' },
  { time: '28分钟前', text: '国务院发布新一轮经济刺激政策，多行业受益明显' },
  { time: '1小时前', text: '某电竞选手直播中意外透露转会消息，粉丝炸锅' },
  { time: '2小时前', text: '多地暴雨预警升级，请广大用户注意出行安全' },
  { time: '3小时前', text: '某品牌新品发布会定档下月，业内普遍看好' },
  { time: '5小时前', text: '娱乐圈某知名经纪人突然宣布离职，原因成谜' },
  { time: '8小时前', text: '年度网络热词评选结果正式公布，你猜中几个？' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          最新快讯
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          实时滚动 · 分秒必达
        </p>
        <div className="max-w-3xl mx-auto">
          {updates.map((u, i) => (
            <div
              key={i}
              className="relative pl-8 pb-6 last:pb-0 border-l-2 border-primary-200 last:border-transparent"
            >
              <div className="absolute left-[-5px] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
              <span className="text-xs text-primary-500 font-medium mb-1 block">
                {u.time}
              </span>
              <p className="text-foreground-700 text-sm leading-relaxed">
                {u.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}